<template>
  <b-container fluid>
    <b-row class="mb-2">
      <b-col cols="auto">
        <b-button variant="primary" @click="testExportHandler">Export</b-button>
      </b-col>
    </b-row>
    <b-row class="test-wrapper">
      <b-col cols="3" class="section left">
        <b-row>
          <b-col class="title p-3">
            <test-type-title
              :disabled="!isTestTypeSequenceChange"
              :tab-selected.sync="tabSelected"
              @reset="resetTestTypesSequence"
              @update="updateTestTypesSequence"
            />
          </b-col>
        </b-row>
        <b-row class="data-wrapper">
          <b-col class="px-0">
            <test-type
              v-model="testTypes"
              :test-type-selected="testTypeSelected"
              @select="testTypeSelectedHandler"
            />
          </b-col>
        </b-row>
      </b-col>
      <b-col cols="9" class="section right">
        <b-row>
          <b-col class="title px-0 py-3">
            <test-title
              :test-type-selected="testTypeSelected"
              :test-selected="testSelected"
              :sub-test-selected="subTestSelected"
              :sub-sub-test-selected="subSubTestSelected"
              :tab-selected.sync="tabSelected"
              :sequence-change="isTestSequenceChange"
              :level.sync="level"
              @reset-test-sequence="resetTestsSequence"
              @update-test-sequence="changeTestsSequenceHandler"
              @reset-sub-test-sequence="resetSubTestsSequence"
              @update-sub-test-sequence="changeSubTestsSequenceHandler"
              @reset-sub-sub-test-sequence="resetSubTestsSequence"
              @update-sub-sub-test-sequence="changeSubTestsSequenceHandler"
              @update-ref-range="updateRefRangeHandler"
            />
          </b-col>
        </b-row>
        <b-row class="test-data-wrapper">
          <template v-if="tabSelected === 'createTestType'">
            <b-col class="px-0">
              <test-type-detail type="create" @submit="createTestTypeHandler" />
            </b-col>
          </template>
          <template v-else-if="!testTypeSelected">
            <b-col class="m-auto">
              <div class="empty-text">
                เลือกประเภทผลตรวจเพื่อแสดงข้อมูลรายการตรวจแต่ละประเภท
              </div>
            </b-col>
          </template>
          <template v-else>
            <template v-if="tabSelected === 'editTestType'">
              <b-col>
                <test-type-detail
                  type="edit"
                  :value="testTypeSelected"
                  @submit="editTestTypeHandler"
                  @delete="deleteTestTypeHandler"
                />
              </b-col>
            </template>
            <template v-else-if="tabSelected === 'testType'">
              <b-col class="px-0">
                <test
                  v-model="tests"
                  class="data-inner-wrapper px-0"
                  :tab-selected="tabSelected"
                  @select="testSelectedHandler"
                />
              </b-col>
            </template>
            <template v-else-if="tabSelected === 'createTest'">
              <b-col class="px-0">
                <test-detail
                  class="px-0 py-3"
                  :tab-selected="tabSelected"
                  test-level="test"
                  :parent="testTypeSelected"
                  type="create"
                  @select="testSelectedHandler"
                  @submit="createTestHandler"
                />
              </b-col>
            </template>
            <template v-else-if="tabSelected === 'editTest'">
              <b-col class="px-0">
                <test-detail
                  class="px-0 py-3"
                  :tab-selected="tabSelected"
                  test-level="test"
                  :value="testSelected"
                  :parent="testTypeSelected"
                  type="edit"
                  @submit="editTestHandler"
                  @delete="deleteTestHandler"
                />
              </b-col>
            </template>
            <template v-else-if="tabSelected === 'subTest'">
              <b-col class="px-0">
                <sub-test
                  v-model="testSelected.sub_test"
                  class="data-inner-wrapper px-0"
                  :tab-selected="tabSelected"
                  @select="subTestSelectedHandler"
                />
              </b-col>
            </template>
            <template v-else-if="tabSelected === 'editSubTest'">
              <b-col class="px-0">
                <test-detail
                  class="px-0 py-3"
                  :tab-selected="tabSelected"
                  test-level="subTest"
                  :value="subTestSelected"
                  :parent="testSelected"
                  type="edit"
                  @submit="editSubTestHandler"
                  @delete="deleteSubTestHandler"
                />
              </b-col>
            </template>
            <template v-else-if="tabSelected === 'createSubTest'">
              <b-col class="px-0">
                <test-detail
                  class="px-0 py-3"
                  :tab-selected="tabSelected"
                  test-level="subTest"
                  :parent="testSelected"
                  type="create"
                  @submit="createSubTestHandler"
                />
              </b-col>
            </template>
            <template v-else-if="tabSelected === 'subSubTest'">
              <b-col class="px-0">
                <sub-sub-test
                  v-model="subTestSelected.sub_test"
                  class="data-inner-wrapper px-0"
                  :tab-selected="tabSelected"
                  @select="subSubTestSelectedHandler"
                />
              </b-col>
            </template>
            <template v-else-if="tabSelected === 'createSubSubTest'">
              <b-col class="px-0">
                <test-detail
                  class="px-0 py-3"
                  :tab-selected="tabSelected"
                  test-level="subSubTest"
                  :parent="subTestSelected"
                  type="create"
                  @submit="createSubTestHandler($event, 'subSubTest')"
                />
              </b-col>
            </template>
            <template v-else-if="tabSelected === 'editSubSubTest'">
              <b-col class="px-0">
                <test-detail
                  class="px-0 py-3"
                  :tab-selected="tabSelected"
                  test-level="subSubTest"
                  :value="subSubTestSelected"
                  :parent="subTestSelected"
                  type="edit"
                  @submit="editSubTestHandler($event, 'subSubTest')"
                  @delete="deleteSubTestHandler($event, 'subSubTest')"
                />
              </b-col>
            </template>
            <template v-else-if="tabSelected === 'testRefRange'">
              <b-col class="px-0">
                <ref-range
                  v-model="refRangeInput"
                  class="data-inner-wrapper px-0 py-3"
                  type="test"
                  :test-id="testSelected.id"
                />
              </b-col>
            </template>
            <template v-else-if="tabSelected === 'subTestRefRange'">
              <b-col class="px-0">
                <ref-range
                  v-model="refRangeInput"
                  class="data-inner-wrapper px-0 py-3"
                  type="subTest"
                  :test-id="subTestSelected.id"
                />
              </b-col>
            </template>
            <template v-else-if="tabSelected === 'subSubTestRefRange'">
              <b-col class="px-0">
                <ref-range
                  v-model="refRangeInput"
                  class="data-inner-wrapper px-0 py-3"
                  type="subTest"
                  :test-id="subSubTestSelected.id"
                />
              </b-col>
            </template>
            <template v-else-if="tabSelected === 'refRangeMultiCreate'">
              <b-col class="px-0">
                <ref-range-multi-create
                  v-model="refRangeInput"
                  :type="testLevelComputed"
                  :test-level="level"
                  :test-id="TestSelection ? TestSelection.id : null"
                  class="data-inner-wrapper px-0 py-3"
                />
              </b-col>
            </template>
            <template v-else-if="tabSelected === 'priceGroup'">
              <b-col class="px-0">
                <price-group
                  v-model="priceGroups"
                  block-btn
                  @submit="updatePriceGroup"
                />
              </b-col>
            </template>
          </template>
        </b-row>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { mapActions } from "vuex";
import TestType from "../../components/Settings/TestView/TestType";
import TestTypeTitle from "../../components/Settings/TestView/TestTypeTitle";
import Test from "../../components/Settings/TestView/Test";
import TestTitle from "../../components/Settings/TestView/TestTitle";
import TestTypeDetail from "../../components/Settings/TestView/TestTypeDetail";
import TestDetail from "../../components/Settings/TestView/TestDetail";
import SubTest from "../../components/Settings/TestView/SubTest";
import SubSubTest from "../../components/Settings/TestView/SubSubTest";
import RefRange from "../../components/Settings/TestView/RefRange";
import RefRangeMultiCreate from "../../components/Settings/TestView/RefRangeMultiCreate";
import PriceGroup from "../../components/Settings/PriceGroup";
import printJS from "print-js";

export default {
  name: "TestView",
  components: {
    PriceGroup,
    RefRangeMultiCreate,
    RefRange,
    SubSubTest,
    SubTest,
    TestDetail,
    TestTypeDetail,
    TestTitle,
    Test,
    TestTypeTitle,
    TestType,
  },
  data() {
    return {
      testTypes: [],
      defaultTestTypes: [],
      defaultTests: [],
      tests: [],
      testTypeSelected: null,
      testSelected: null,
      tabSelected: null,
      subTestSelected: null,
      subSubTestSelected: null,
      level: "testType",
      refRangeInput: [],
      priceGroups: [],
    };
  },
  computed: {
    testLevelComputed() {
      if (this.level === "test") {
        return "test";
      } else if (this.level === "subTest") {
        return "test";
      } else if (this.level === "subSubTest") {
        return "subTest";
      } else {
        return false;
      }
    },
    defaultTestTypeSequence() {
      return this.defaultTestTypes.map((testType) => testType.sequence); // array includes test types sequence
    },
    isTestTypeSequenceChange() {
      // transform test type keep only sequence
      const changeSequence = this.testTypes.map((val) => val.sequence);
      return !this.$_.isEqual(this.defaultTestTypeSequence, changeSequence); // boolean return test types sequence change
    },
    defaultTestSequence() {
      return this.defaultTests.map((test) => test.sequence); // array includes test sequence
    },
    defaultSubTestSequence() {
      return this.defaultTests
        .find((test) => test.id === this.testSelected.id)
        .sub_test.map((subTest) => subTest.sequence); // array includes sub test sequence
    },
    defaultSubSubTestSequence() {
      return this.defaultTests
        .find((test) => test.id === this.testSelected.id)
        .sub_test.find((subTest) => subTest.id === this.subTestSelected.id)
        .sub_test.map((subSubTest) => subSubTest.sequence); // array includes sub sub test sequence
    },
    isTestSequenceChange() {
      // transform test keep only sequence
      if (this.level === "testType") {
        const changeSequence = this.tests.map((val) => val.sequence);
        return !this.$_.isEqual(this.defaultTestSequence, changeSequence); // boolean return test sequence change
      } else if (this.level === "test") {
        const changeSequence = this.testSelected.sub_test.map(
          (val) => val.sequence
        );
        return !this.$_.isEqual(this.defaultSubTestSequence, changeSequence); // boolean return test sequence change
      } else if (this.level === "subTest") {
        const changeSequence = this.subTestSelected.sub_test.map(
          (val) => val.sequence
        );
        return !this.$_.isEqual(this.defaultSubSubTestSequence, changeSequence); // boolean return test sequence change
      } else {
        return false;
      }
    },
    TestSelection() {
      if (this.level === "test") {
        return this.testSelected;
      } else if (this.level === "subTest") {
        return this.subTestSelected;
      } else if (this.level === "subSubTest") {
        return this.subSubTestSelected;
      } else {
        return null;
      }
    },
  },
  watch: {
    tabSelected(value) {
      if (value === "priceGroup") {
        this.assignPriceGroup();
      }
    },
  },
  async mounted() {
    this.defaultTestTypes = await this.getTestTypes(); // get test types to default
    this.testTypes = this.$rfdc(this.defaultTestTypes); // clone test types from default
  },
  methods: {
    ...mapActions({
      getTestTypes: "Settings/getTestTypeList",
      updateSequenceTestType: "Settings/updateSequenceTestType",
      updateSequenceTest: "Settings/updateSequenceTest",
      updateSequenceSubTest: "Settings/updateSequenceSubTest",
      createTestType: "Settings/createTestType",
      updateTestType: "Settings/updateTestType",
      deleteTestType: "Settings/deleteTestType",
      getTestByTestTypeId: "Settings/getTestByTestTypeId",
      createTest: "Settings/createTest",
      updateTest: "Settings/updateTest",
      deleteTest: "Settings/deleteTest",
      createSubTest: "Settings/createSubTest",
      updateSubTest: "Settings/updateSubTest",
      deleteSubTest: "Settings/deleteSubTest",
      updateRefRangeList: "Test/updateRefRangeList",
      getPriceGroup: "Settings/getPriceGroupByTestId",
      updateTestPriceGroup: "Settings/updateTestPriceGroup",
      exportTest: "Settings/exportTest",
    }),
    async testExportHandler() {
      this.$store.state.isLoading = true;
      let res;
      try {
        res = await this.exportTest();
      } catch (err) {
        this.$store.state.isLoading = false;
        return;
      }
      this.$store.state.isLoading = false;
      if (res.pdf_file) {
        printJS({
          printable: res.pdf_file,
          type: "pdf",
          showModal: true,
          base64: true,
        });
      }
    },
    resetTestTypesSequence() {
      this.testTypes = this.$rfdc(this.defaultTestTypes); // clone test types from default
      this.testTypeSelected = null; // reset test types selected
    },
    async updateTestTypesSequence(password) {
      // add loading
      this.$store.state.isLoading = true;
      // transform test type keep only sequence by index and test type id
      const testTypesSequenceUpdate = this.testTypes.map((testType, index) => ({
        id: testType.id,
        sequence: index + 1,
      }));

      try {
        // update test type sequence axios
        await this.updateSequenceTestType({
          payload: testTypesSequenceUpdate,
          password,
        });
      } catch (e) {
        //error occur
        // alert error
        await this.$swal.fire("เกิดข้อผิดพลาด", e.message, "error");
        // remove loading
        this.$store.state.isLoading = false;
      }
      // get test types to default
      this.defaultTestTypes = await this.getTestTypes();
      // clone test types from default
      this.testTypes = this.$rfdc(this.defaultTestTypes);
      this.testTypeSelected = null; // reset test types selected
      // alert success
      await this.$swal.fire("สำเร็จ", "บันทึกลำดับใหม่เสร็จสิ้น", "success");
      // remove loading
      this.$store.state.isLoading = false;
    },
    async testTypeSelectedHandler(value) {
      // add loading
      this.$store.state.isLoading = true;
      // assign test type select
      this.testTypeSelected = value;
      try {
        // get test from axios then keep in default
        this.defaultTests = await this.getTestByTestTypeId(
          this.testTypeSelected.id
        );
        // assign test from default test
        this.tests = this.$rfdc(this.defaultTests);
      } catch (e) {
        // alert error
        await this.$swal.fire("เกิดข้อผิดพลาด", e.message, "error");
        // reset test type select
        this.testTypeSelected = null;
        // change level to test type
        this.level = "testType";
        // remove loading
        this.$store.state.isLoading = false;
        return;
      }
      // select tab to test type that include test list
      this.tabSelected = "testType";
      // change level to test type
      this.level = "testType";
      // remove loading
      this.$store.state.isLoading = false;
    },
    async createTestTypeHandler(input) {
      // add loading
      this.$store.state.isLoading = true;
      try {
        // post method create test type to axios
        await this.createTestType(input);
      } catch (e) {
        // alert error
        await this.$swal.fire("เกิดข้อผิดพลาด", e.message, "error");
        // return to testType tab selected
        this.tabSelected = "testType";
        // remove loading
        this.$store.state.isLoading = false;
        return;
      }
      // get test types to default
      this.defaultTestTypes = await this.getTestTypes();
      // clone test types from default
      this.testTypes = this.$rfdc(this.defaultTestTypes);
      // alert success
      await this.$swal.fire("สำเร็จ", "สร้างประเภทผลตรวจเสร็จสิ้น", "success");
      // remove loading
      this.$store.state.isLoading = false;
    },
    async editTestTypeHandler(input) {
      // add loading
      this.$store.state.isLoading = true;
      try {
        // post method update test type to axios
        await this.updateTestType(input);
      } catch (e) {
        // alert error
        await this.$swal.fire("เกิดข้อผิดพลาด", e.message, "error");
        // remove loading
        this.$store.state.isLoading = false;
        return;
      }
      // get test types to default
      this.defaultTestTypes = await this.getTestTypes();
      // clone test types from default
      this.testTypes = this.$rfdc(this.defaultTestTypes);
      // return tab to test type that include test list
      this.tabSelected = "testType";
      // alert success
      await this.$swal.fire("สำเร็จ", "ลบประเภทผลตรวจเสร็จสิ้น", "success");
      // remove loading
      this.$store.state.isLoading = false;
    },
    async deleteTestTypeHandler(password) {
      // add loading
      this.$store.state.isLoading = true;
      try {
        // post method delete test type to axios
        await this.deleteTestType({ id: this.testTypeSelected.id, password });
      } catch (e) {
        // alert error
        await this.$swal.fire("เกิดข้อผิดพลาด", e.message, "error");
        // remove loading
        this.$store.state.isLoading = false;
        return;
      }
      // get test types to default
      this.defaultTestTypes = await this.getTestTypes();
      // clone test types from default
      this.testTypes = this.$rfdc(this.defaultTestTypes);
      // return tab to test type that include test list
      this.tabSelected = "testType";
      // reset test type select
      this.testTypeSelected = null;
      // change level to test type
      this.level = "testType";
      // alert success
      await this.$swal.fire("สำเร็จ", "แก้ไขประเภทผลตรวจเสร็จสิ้น", "success");
      // remove loading
      this.$store.state.isLoading = false;
    },
    async testSelectedHandler(value) {
      this.testSelected = value;
      // return tab to test type that include test list
      this.tabSelected = "editTest";
      // change level to test type
      this.level = "test";
    },
    resetTestsSequence() {
      this.tests = this.$rfdc(this.defaultTests); // clone tests from default
      this.testSelected = null; // reset test selected
    },
    async changeTestsSequenceHandler(password) {
      // add loading
      this.$store.state.isLoading = true;
      // transform test type keep only sequence by index and test type id
      const testsSequenceUpdate = this.tests.map((test, index) => ({
        id: test.id,
        sequence: index + 1,
      }));

      try {
        // update test sequence axios
        await this.updateSequenceTest({
          payload: testsSequenceUpdate,
          password,
        });
      } catch (e) {
        //error occur
        // alert error
        await this.$swal.fire("เกิดข้อผิดพลาด", e.message, "error");
        // remove loading
        this.$store.state.isLoading = false;
      }
      try {
        // get test from axios then keep in default
        this.defaultTests = await this.getTestByTestTypeId(
          this.testTypeSelected.id
        );
        // assign test from default test
        this.tests = this.$rfdc(this.defaultTests);
      } catch (e) {
        // alert error
        await this.$swal.fire("เกิดข้อผิดพลาด", e.message, "error");
        // reset test type select
        this.testTypeSelected = null;
        // remove loading
        this.$store.state.isLoading = false;
        return;
      }
      // alert success
      await this.$swal.fire("สำเร็จ", "บันทึกลำดับใหม่เสร็จสิ้น", "success");
      // remove loading
      this.$store.state.isLoading = false;
    },
    async editTestHandler(input) {
      // add loading
      this.$store.state.isLoading = true;
      try {
        // post method update test type to axios
        await this.updateTest(input);
      } catch (e) {
        // alert error
        await this.$swal.fire("เกิดข้อผิดพลาด", e.message, "error");
        // remove loading
        this.$store.state.isLoading = false;
        return;
      }
      // get test types to default
      this.defaultTestTypes = await this.getTestTypes();
      // clone test types from default
      this.testTypes = this.$rfdc(this.defaultTestTypes);
      // return tab to test type that include test list
      try {
        // get test from axios then keep in default
        this.defaultTests = await this.getTestByTestTypeId(
          this.testTypeSelected.id
        );
        // assign test from default test
        this.tests = this.$rfdc(this.defaultTests);
      } catch (e) {
        // alert error
        await this.$swal.fire("เกิดข้อผิดพลาด", e.message, "error");
        // reset test type select
        this.testTypeSelected = null;
        // change level to test type
        this.level = "testType";
        // remove loading
        this.$store.state.isLoading = false;
        return;
      }
      this.tabSelected = "testType";
      this.level = "testType";
      this.testTypeSelected = this.testTypes.find(
        (testType) => testType.id === this.testTypeSelected.id
      );
      this.testSelected = null;
      // alert success
      await this.$swal.fire("สำเร็จ", "แก้ไขผลตรวจเสร็จสิ้น", "success");
      // remove loading
      this.$store.state.isLoading = false;
    },
    async createTestHandler(input) {
      // add loading
      this.$store.state.isLoading = true;
      try {
        // post method create test type to axios
        await this.createTest(input);
      } catch (e) {
        // alert error
        await this.$swal.fire("เกิดข้อผิดพลาด", e.message, "error");
        // remove loading
        this.$store.state.isLoading = false;
        return;
      }
      // get test types to default
      this.defaultTestTypes = await this.getTestTypes();
      // clone test types from default
      this.testTypes = this.$rfdc(this.defaultTestTypes);
      // return tab to test type that include test list
      try {
        // get test from axios then keep in default
        this.defaultTests = await this.getTestByTestTypeId(
          this.testTypeSelected.id
        );
        // assign test from default test
        this.tests = this.$rfdc(this.defaultTests);
      } catch (e) {
        // alert error
        await this.$swal.fire("เกิดข้อผิดพลาด", e.message, "error");
        // reset test type select
        this.testTypeSelected = null;
        // change level to test type
        this.level = "testType";
        // remove loading
        this.$store.state.isLoading = false;
        return;
      }
      this.tabSelected = "testType";
      this.level = "testType";
      this.testTypeSelected = this.testTypes.find(
        (testType) => testType.id === this.testTypeSelected.id
      );
      this.testSelected = null;
      // alert success
      await this.$swal.fire("สำเร็จ", "สร้างผลตรวจเสร็จสิ้น", "success");
      // remove loading
      this.$store.state.isLoading = false;
    },
    subTestSelectedHandler(subTest) {
      this.level = "subTest";
      this.tabSelected = "editSubTest";
      this.subTestSelected = subTest;
    },
    async deleteTestHandler(id) {
      // add loading
      this.$store.state.isLoading = true;
      try {
        // post method delete test type to axios
        await this.deleteTest(id);
      } catch (e) {
        // alert error
        await this.$swal.fire("เกิดข้อผิดพลาด", e.message, "error");
        // remove loading
        this.$store.state.isLoading = false;
        return;
      }
      // get test types to default
      this.defaultTestTypes = await this.getTestTypes();
      // clone test types from default
      this.testTypes = this.$rfdc(this.defaultTestTypes);
      // return tab to test type that include test list
      try {
        // get test from axios then keep in default
        this.defaultTests = await this.getTestByTestTypeId(
          this.testTypeSelected.id
        );
        // assign test from default test
        this.tests = this.$rfdc(this.defaultTests);
      } catch (e) {
        // alert error
        await this.$swal.fire("เกิดข้อผิดพลาด", e.message, "error");
        // reset test type select
        this.testTypeSelected = null;
        // change level to test type
        this.level = "testType";
        // remove loading
        this.$store.state.isLoading = false;
        return;
      }
      this.tabSelected = "testType";
      this.level = "testType";
      this.testTypeSelected = this.testTypes.find(
        (testType) => testType.id === this.testTypeSelected.id
      );
      this.testSelected = null;
      // alert success
      await this.$swal.fire("สำเร็จ", "ลบผลตรวจเสร็จสิ้น", "success");
      // remove loading
      this.$store.state.isLoading = false;
    },
    async editSubTestHandler(input, type = "subTest") {
      // add loading
      this.$store.state.isLoading = true;
      try {
        // post method update sub test to axios
        await this.updateSubTest(input);
      } catch (e) {
        // alert error
        await this.$swal.fire("เกิดข้อผิดพลาด", e.message, "error");
        // remove loading
        this.$store.state.isLoading = false;
        return;
      }
      // get test types to default
      this.defaultTestTypes = await this.getTestTypes();
      // clone test types from default
      this.testTypes = this.$rfdc(this.defaultTestTypes);
      // return tab to test type that include test list
      try {
        // get test from axios then keep in default
        this.defaultTests = await this.getTestByTestTypeId(
          this.testTypeSelected.id
        );
        // assign test from default test
        this.tests = this.$rfdc(this.defaultTests);
      } catch (e) {
        // alert error
        await this.$swal.fire("เกิดข้อผิดพลาด", e.message, "error");
        // reset test type select
        this.testTypeSelected = null;
        // change level to test type
        this.level = "testType";
        // remove loading
        this.$store.state.isLoading = false;
        return;
      }
      this.tabSelected = "subTest";
      this.level = "test";
      this.testTypeSelected = this.testTypes.find(
        (testType) => testType.id === this.testTypeSelected.id
      );
      this.testSelected = this.tests.find(
        (test) => test.id === this.testSelected.id
      );

      if (type === "subTest") {
        this.subTestSelected = null;
      } else if (type === "subSubTest") {
        this.subSubTestSelected = null;
      }

      // alert success
      await this.$swal.fire("สำเร็จ", "แก้ไขผลตรวจย่อยเสร็จสิ้น", "success");
      // remove loading
      this.$store.state.isLoading = false;
    },
    async createSubTestHandler(input, type = "subTest") {
      // add loading
      this.$store.state.isLoading = true;
      try {
        // post method create sub test to axios
        await this.createSubTest(input);
      } catch (e) {
        // alert error
        await this.$swal.fire("เกิดข้อผิดพลาด", e.message, "error");
        // remove loading
        this.$store.state.isLoading = false;
        return;
      }
      // get test types to default
      this.defaultTestTypes = await this.getTestTypes();
      // clone test types from default
      this.testTypes = this.$rfdc(this.defaultTestTypes);
      // return tab to test type that include test list
      try {
        // get test from axios then keep in default
        this.defaultTests = await this.getTestByTestTypeId(
          this.testTypeSelected.id
        );
        // assign test from default test
        this.tests = this.$rfdc(this.defaultTests);
      } catch (e) {
        // alert error
        await this.$swal.fire("เกิดข้อผิดพลาด", e.message, "error");
        // reset test type select
        this.testTypeSelected = null;
        // change level to test type
        this.level = "testType";
        // remove loading
        this.$store.state.isLoading = false;
        return;
      }
      this.tabSelected = "subTest";
      this.level = "test";
      this.testTypeSelected = this.testTypes.find(
        (testType) => testType.id === this.testTypeSelected.id
      );
      this.testSelected = this.tests.find(
        (test) => test.id === this.testSelected.id
      );
      if (type === "subTest") {
        this.subTestSelected = null;
      } else if (type === "subSubTest") {
        this.subSubTestSelected = null;
      }
      // alert success
      await this.$swal.fire("สำเร็จ", "สร้างผลตรวจย่อยเสร็จสิ้น", "success");
      // remove loading
      this.$store.state.isLoading = false;
    },
    async deleteSubTestHandler(id, type = "subTest") {
      // add loading
      this.$store.state.isLoading = true;
      try {
        // post method create sub test to axios
        await this.deleteSubTest(id);
      } catch (e) {
        // alert error
        await this.$swal.fire("เกิดข้อผิดพลาด", e.message, "error");
        // remove loading
        this.$store.state.isLoading = false;
        return;
      }
      // get test types to default
      this.defaultTestTypes = await this.getTestTypes();
      // clone test types from default
      this.testTypes = this.$rfdc(this.defaultTestTypes);
      // return tab to test type that include test list
      try {
        // get test from axios then keep in default
        this.defaultTests = await this.getTestByTestTypeId(
          this.testTypeSelected.id
        );
        // assign test from default test
        this.tests = this.$rfdc(this.defaultTests);
      } catch (e) {
        // alert error
        await this.$swal.fire("เกิดข้อผิดพลาด", e.message, "error");
        // reset test type select
        this.testTypeSelected = null;
        // change level to test type
        this.level = "testType";
        // remove loading
        this.$store.state.isLoading = false;
        return;
      }
      this.tabSelected = "subTest";
      this.level = "test";
      this.testTypeSelected = this.testTypes.find(
        (testType) => testType.id === this.testTypeSelected.id
      );
      this.testSelected = this.tests.find(
        (test) => test.id === this.testSelected.id
      );
      if (type === "subTest") {
        this.subTestSelected = null;
      } else if (type === "subSubTest") {
        this.subSubTestSelected = null;
      }
      // alert success
      await this.$swal.fire("สำเร็จ", "ลบผลตรวจย่อยเสร็จสิ้น", "success");
      // remove loading
      this.$store.state.isLoading = false;
    },
    subSubTestSelectedHandler(subSubTest) {
      this.level = "subSubTest";
      this.tabSelected = "editSubSubTest";
      this.subSubTestSelected = subSubTest;
    },
    resetSubTestsSequence(type = "subTest") {
      this.tests = this.$rfdc(this.defaultTests); // clone tests from default
      this.testSelected = this.tests.find(
        (test) => test.id === this.testSelected.id
      );
      if (type === "subTest") {
        this.subTestSelected = null; // reset sub test selected
      } else {
        this.subTestSelected = this.testSelected.sub_test.find(
          (subTest) => subTest.id === this.subTestSelected.id
        );
        this.subSubTestSelected = null;
      }
    },
    async changeSubTestsSequenceHandler({ type = "subTest", password }) {
      // add loading
      this.$store.state.isLoading = true;
      let subTestsSequenceUpdate = [];
      if (type === "subTest") {
        subTestsSequenceUpdate = this.testSelected.sub_test.map(
          (subTest, index) => ({
            id: subTest.id,
            sequence: index + 1,
          })
        );
      } else {
        subTestsSequenceUpdate = this.subTestSelected.sub_test.map(
          (subSubTest, index) => ({
            id: subSubTest.id,
            sequence: index + 1,
          })
        );
      }
      try {
        // update sub test sequence axios
        await this.updateSequenceSubTest({
          payload: subTestsSequenceUpdate,
          password,
        });
      } catch (e) {
        //error occur
        // alert error
        await this.$swal.fire("เกิดข้อผิดพลาด", e.message, "error");
        // remove loading
        this.$store.state.isLoading = false;
      }
      try {
        // get test from axios then keep in default
        this.defaultTests = await this.getTestByTestTypeId(
          this.testTypeSelected.id
        );
        // assign test from default test
        this.tests = this.$rfdc(this.defaultTests);
        this.testSelected = this.tests.find(
          (test) => test.id === this.testSelected.id
        );
      } catch (e) {
        // alert error
        await this.$swal.fire("เกิดข้อผิดพลาด", e.message, "error");
        // reset test type select
        this.testTypeSelected = null;
        // remove loading
        this.$store.state.isLoading = false;
        return;
      }
      // alert success
      await this.$swal.fire("สำเร็จ", "บันทึกลำดับใหม่เสร็จสิ้น", "success");
      // remove loading
      this.$store.state.isLoading = false;
    },
    async updateRefRangeHandler(password) {
      // add loading
      this.$store.state.isLoading = true;
      try {
        await this.updateRefRangeList({
          payload: this.refRangeInput,
          password,
        });
      } catch (e) {
        //error occur
        // alert error
        await this.$swal.fire("เกิดข้อผิดพลาด", e.message, "error");
        // remove loading
        this.$store.state.isLoading = false;
      }
      if (this.level === "subSubTest") {
        this.tabSelected = "editSubSubTest";
      } else if (this.level === "test") {
        this.tabSelected = "editTest";
      } else if (this.level === "subTest") {
        this.tabSelected = "editSubTest";
      }

      this.refRangeInput = [];
      // alert success
      await this.$swal.fire(
        "สำเร็จ",
        "บันทึก Ref Range ใหม่เสร็จสิ้น",
        "success"
      );
      // remove loading
      this.$store.state.isLoading = false;
    },
    async updatePriceGroup(password) {
      this.$store.state.isLoading = true;

      try {
        await this.updateTestPriceGroup({
          payload: this.priceGroups,
          password,
        });
      } catch (e) {
        await this.$swal.fire("เกิดข้อผิดพลาด", e.message, "error");
        this.$store.state.isLoading = false;
        return;
      }
      this.priceGroups = [];
      this.tabSelected = "editTest";
      await this.$swal.fire("สำเร็จ", "บันทึกชุดตรวจเสร็จสิ้น", "success");
      this.$store.state.isLoading = false;
    },
    async assignPriceGroup() {
      this.$store.state.isLoading = true;
      let priceGroupsResponse;
      try {
        priceGroupsResponse = await this.getPriceGroup(this.testSelected.id);
      } catch (e) {
        await this.$swal.fire("เกิดข้อผิดพลาด", e.message, "error");
        this.$store.state.isLoading = false;
        return;
      }

      this.priceGroups = priceGroupsResponse.map((priceGroup) => ({
        detail: priceGroup.detail,
        test_id: this.testSelected.id,
        price_group_id: priceGroup.id,
        price: priceGroup.price ? priceGroup.price.price : 0,
      }));

      this.$store.state.isLoading = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.test-wrapper {
  border: 1px solid black;
  min-width: 1200px;
  transition: all 130ms ease-out;
  .section {
    .data-wrapper {
      height: 60vh;
      overflow-y: auto;
    }
    &.right {
      border-left: 1px solid black;
      .test-data-wrapper {
        height: 100%;

        .empty-text {
          font-style: italic;
        }

        .data-inner-wrapper {
          transition: all 130ms ease-out;
          height: 53vh;
          overflow-y: auto;
        }
      }
    }
    .title {
      background: #4e555b;
      color: white;
    }
    .sub-title {
      background: #e2e2e2;
      border-top: 1px solid black;
      border-bottom: 1px solid black;
    }
  }
}
</style>
